module.exports = __webpack_public_path__ + "mobile-phone-format-1.webm";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-devices/assets/mobile-phone-format-1.webm
// module id = 1161
// module chunks = 10